import { render, staticRenderFns } from "./AccreditationOM.vue?vue&type=template&id=4ebd8283&scoped=true&"
import script from "./AccreditationOM.vue?vue&type=script&lang=js&"
export * from "./AccreditationOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd8283",
  null
  
)

export default component.exports